_ = require 'underscore'
PluginButtonView = require 'views/plugin/plugin-button-view'
t = require('views/internal/teacup-with-helpers')()
track = require 'debug/track'
trackUe = require 'debug/trackUe'

template = t.renderable ({ icon, text }) ->
  lightBrightness = @model.get('prefs').backgroundBrightness == 'light'
  coloredIcon =
    if _.isString(icon)
      iconColor = if lightBrightness then '000' else 'f6f6f6'
      "#{ icon }?color=#{ iconColor }"
    else if lightBrightness && _.isString(icon?.light)
      icon.light
    else if !lightBrightness && _.isString(icon?.dark)
      icon.dark
  if coloredIcon?
    t.span '.board-header-btn-icon.icon-sm.plugin-icon',
      class: t.classify(recolorable: _.isString(icon))
      style: t.stylify
        'background-image': t.urlify coloredIcon
  t.span '.board-header-btn-text.u-text-underline', ->
    t.text text
  return

module.exports = class PluginHeaderButtonView extends PluginButtonView
  className: ->
    if @options.pluginButton?.icon?
      'board-header-btn'
    else
      'board-header-btn board-header-btn-without-icon'
  template: template

  trackClick: (pluginButton) ->
    track("Board Header", "Board Plugin Button", pluginButton.text)
    trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', pluginButton.idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-header-button-view.coffee